import { type FileValue, type FileValues } from '@dfg/brahma-types';
import { STATUS } from './file.constants';
// import { type QueuedFile } from '@brahma/hooks';
export const formatFileResponse = (inputField: {
  allowMultipleUploads?: boolean;
  file?: FileValue | FileValues;
}): any[] => {
  if (
    !inputField.file ||
    Object.keys(inputField.file).length === 0 ||
    (Array.isArray(inputField.file) && inputField.file.length === 0)
  ) {
    return [];
  }

  if (Array.isArray(inputField.file)) {
    return inputField.file.map((inputFileField) => ({
      response: {
        entities: [{ ...inputFileField }]
      },
      file: {
        ...inputFileField,
        name: inputFileField?.metadata?.fileName ?? 'NA',
        size: inputFileField?.metadata?.fileSize,
        type: inputFileField?.metadata?.contentType,
        status: STATUS.STATUS_EXISTING
      } as unknown as File,
      status: STATUS.STATUS_SUCCESS,
      progress: 100,
      url: inputFileField?.fileUri ?? inputFileField?.url ?? ''
    }));
  }

  return [
    {
      response: {
        entities: Array.isArray(inputField.file)
          ? inputField.file
          : [{ ...inputField.file }]
      },
      file: {
        ...inputField.file,
        name: inputField.file?.metadata?.fileName ?? 'NA',
        size: Number(inputField.file?.metadata?.fileSize),
        type: inputField.file?.metadata?.contentType,
        status: STATUS.STATUS_EXISTING
      } as unknown as File,
      url: inputField.file?.fileUri ?? inputField.file?.url ?? '',
      status: STATUS.STATUS_EXISTING,
      progress: 100
    }
  ];
};
